import React from 'react';
import { Box, Typography } from '@mui/material';

const ProductEmptyState: React.FC = () => (
  <Box sx={{ textAlign: 'center', my: 4 }}>
    <Typography variant="body1" color="text.secondary">
      Product information not available
    </Typography>
  </Box>
);

export default ProductEmptyState;
